export default "__VITE_ASSET__DN0g9uD___"